import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronRight } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Typography } from "@mui/material";
var ConfirmButtonText;
(function (ConfirmButtonText) {
    ConfirmButtonText["PAYMENT_COMPLETE"] = "This payment is complete.";
    ConfirmButtonText["CONFIRM_PAYMENT"] = "Confirm Payment";
})(ConfirmButtonText || (ConfirmButtonText = {}));
/**
 * Renders a payment confirmation button for Edit Flow
 *
 * Depending on the order payment status, this component displays either:
 * - A text label indicating that payment is complete when the current order is paid
 *   but not all orders are paid.
 * - A clickable loading button prompting the user to confirm payment when the
 *   current order is not paid.
 * - Nothing (null) when none of the conditions are met.
 *
 * @component
 * @param {boolean} props.disabled - Indicates whether the button should be disabled.
 * @param {boolean} props.loading - Indicates whether the button should display a loading state.
 * @param {boolean} props.isCurrentOrderPaid - Flag indicating if the current order has been paid.
 * @param {boolean} props.allOrdersPaid - Flag indicating if all orders have been paid.
 * @param {() => void} props.onClick - Callback function to handle the button click.
 * @returns {JSX.Element|null} The rendered button or text element based on the payment status, or null if no condition matches.
 */
export const ConfirmPaymentButton = ({ disabled, loading, isCurrentOrderPaid, allOrdersPaid, onClick, }) => {
    if (isCurrentOrderPaid && !allOrdersPaid) {
        return (_jsx(Typography, Object.assign({ sx: {
                flexGrow: {
                    xx: 1,
                    sm: 0,
                },
                margin: {
                    xx: "auto",
                    sm: 0,
                },
            }, textAlign: "center" }, { children: ConfirmButtonText.PAYMENT_COMPLETE })));
    }
    if (!isCurrentOrderPaid) {
        return (_jsx(LoadingButton, Object.assign({ sx: {
                minHeight: "inherit",
                flexGrow: {
                    xx: 1,
                    sm: 0,
                },
            }, variant: "contained", disabled: disabled, loading: loading, endIcon: _jsx(ChevronRight, {}), onClick: () => {
                onClick();
            } }, { children: ConfirmButtonText.CONFIRM_PAYMENT })));
    }
    return null;
};
